import { mdy, dollars, csvText } from './shared';

// QuickBooks Online "Import journal entries" CSV. Lines that share a Journal
// No. form one entry; Account Name must exist in the chart of accounts
// (Parent:Subaccount); Location/Class are honoured when those features are
// on. One of Debits/Credits per line, the other blank.
export const QBO_HEADER = ['Journal No', 'Journal Date', 'Currency', 'Memo', 'Account Name', 'Debits', 'Credits', 'Description', 'Name', 'Location', 'Class'];

export function buildQboJournalCsv(entries) {
  const rows = [QBO_HEADER];
  for (const e of entries) {
    const date = mdy(e.periodEnd);
    for (const l of e.lines || []) {
      if (l.amount === 0) continue;
      rows.push([
        e.docNum, date, 'CAD', e.memo, l.account,
        l.side === 'debit' ? dollars(l.amount) : '',
        l.side === 'credit' ? dollars(l.amount) : '',
        l.label, '', e.class || '', e.class || '',
      ]);
    }
  }
  return csvText(rows);
}
